<script>
export default {
    props: {
        quizTitle: { type: String, default: '' },
        score: { type: [Number, String], default: 0 },
        maxScore: { type: [Number, String], default: 0 },
        siteName: { type: String, default: '' },
        siteLogo: { type: String, default: '' },
        siteUrl: { type: String, default: '' },
        tagline: { type: String, default: 'Can you beat me?' },
        bgStart: { type: String, default: '#4c1d95' },
        bgEnd: { type: String, default: '#7c3aed' },
        accent: { type: String, default: '#fde047' },
    },
    data() {
        return {
            width: 600,
            height: 360,
        }
    },
    methods: {
        draw() {
            let component = this;
            let canvas = component.$refs.canvas;
            if (!canvas) {
                return;
            }
            let ctx = canvas.getContext('2d');

            // Background
            let gradient = ctx.createLinearGradient(0, 0, component.width, component.height);
            gradient.addColorStop(0, component.bgStart);
            gradient.addColorStop(1, component.bgEnd);
            ctx.fillStyle = gradient;
            ctx.fillRect(0, 0, component.width, component.height);

            // Foreground text helper
            let drawText = function () {
                ctx.textAlign = 'center';

                // Quiz title
                ctx.fillStyle = '#ffffff';
                ctx.font = '600 26px Arial, sans-serif';
                component.wrapText(ctx, component.quizTitle, component.width / 2, 150, component.width - 80, 32);

                // Score
                ctx.fillStyle = component.accent;
                ctx.font = '700 72px Arial, sans-serif';
                ctx.fillText(component.score + ' / ' + component.maxScore, component.width / 2, 240);

                // Tagline
                ctx.fillStyle = '#ffffff';
                ctx.font = '400 22px Arial, sans-serif';
                ctx.fillText(component.tagline, component.width / 2, 285);

                // Site URL / name footer
                ctx.fillStyle = 'rgba(255,255,255,0.85)';
                ctx.font = '500 18px Arial, sans-serif';
                ctx.fillText(component.siteUrl || component.siteName, component.width / 2, 325);
            };

            if (component.siteLogo) {
                let logo = new Image();
                logo.crossOrigin = 'anonymous';
                logo.onload = function () {
                    let maxLogoWidth = 220;
                    let maxLogoHeight = 70;
                    let ratio = Math.min(maxLogoWidth / logo.width, maxLogoHeight / logo.height);
                    let w = logo.width * ratio;
                    let h = logo.height * ratio;
                    ctx.drawImage(logo, (component.width - w) / 2, 30, w, h);
                    drawText();
                };
                logo.onerror = function () {
                    // Fall back to site name text if the logo can't be loaded/tainted.
                    ctx.fillStyle = '#ffffff';
                    ctx.textAlign = 'center';
                    ctx.font = '700 30px Arial, sans-serif';
                    ctx.fillText(component.siteName, component.width / 2, 70);
                    drawText();
                };
                logo.src = component.siteLogo;
            } else {
                ctx.fillStyle = '#ffffff';
                ctx.textAlign = 'center';
                ctx.font = '700 30px Arial, sans-serif';
                ctx.fillText(component.siteName, component.width / 2, 70);
                drawText();
            }
        },
        wrapText(ctx, text, x, y, maxWidth, lineHeight) {
            if (!text) {
                return;
            }
            let words = String(text).split(' ');
            let line = '';
            let lines = [];
            words.forEach(function (word) {
                let test = line ? line + ' ' + word : word;
                if (ctx.measureText(test).width > maxWidth && line) {
                    lines.push(line);
                    line = word;
                } else {
                    line = test;
                }
            });
            lines.push(line);
            // Vertically center the (1-2) title lines around y.
            let startY = y - ((lines.length - 1) * lineHeight) / 2;
            lines.forEach(function (l, i) {
                ctx.fillText(l, x, startY + i * lineHeight);
            });
        },
    },
    watch: {
        score() { this.draw(); },
        maxScore() { this.draw(); },
        quizTitle() { this.draw(); },
        bgStart() { this.draw(); },
        bgEnd() { this.draw(); },
        accent() { this.draw(); },
    },
    mounted() {
        this.draw();
    },
}
</script>
<template>
    <div class="aktion-quiz-result-card">
        <canvas ref="canvas" :width="width" :height="height" class="aktion-quiz-result-card__canvas"></canvas>
    </div>
</template>
